export function parseGeoCoderResult(data) {
  if (!data.suggestions || !data.suggestions.length) {
    return [];
  }

  const filteredSuggestions = data.suggestions
    .map(d => {
      d.label = d.label.replace('Deutschland, ', '');
      return d;
    })
    .filter(
      d =>
        !['county', 'state', 'district', 'country'].includes(d.matchLevel) &&
        d.label !== '' &&
        d.label !== 'Deutschland'
    );

  return filteredSuggestions.map(s => ({
    __label: `${s.address.city}${s.address.street ? `, ${s.address.street}` : ''}`,
    ...s
  }));
}

export function getSuggestUrl(opts = {}) {
  const baseUrl = 'https://autocomplete.geocoder.api.here.com/6.2/suggest.json';
  const params = Object.keys(opts)
    .map(key => `${key}=${opts[key]}`)
    .join('&');

  return `${baseUrl}?${params}`;
}

// export function getSuggestUrl(opts) {
//   if (opts.center.length) {
//     return getSuggestUrlWithCenter(opts);
//   }

//   return `https://autocomplete.geocoder.api.here.com/6.2/suggest.json?query=${opts.query}&app_id=${opts.app_id}&app_code=${opts.app_code}&country=${opts.country}&language=de`;
// }

export function getSuggestUrlWithCenter(opts) {
  return `https://autocomplete.geocoder.api.here.com/6.2/suggest.json?query=${opts.query}&app_id=${
    opts.app_id
  }&app_code=${opts.app_code}&country=${opts.country}&language=de&prox=${opts.center.join(',')},${opts.radius}`;
}

export function getGeoCodingUrl(opts) {
  return `https://geocoder.api.here.com/6.2/geocode.json?locationid=${opts.locationId}&jsonattributes=1&gen=9&app_id=${opts.app_id}&app_code=${opts.app_code}`;
}

export default {
  parseGeoCoderResult,
  getSuggestUrl,
  getGeoCodingUrl
};
